module.exports = __webpack_public_path__ + "img/1.e1f7a49f.png";